import {
  Component,
  OnInit,
  Input,
  SimpleChange,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  ConfigTableInterface,
  ResponseResult,
} from 'src/app/shares/interfaces';
import {
  StatusCode,
  Action,
  Pagination,
  Types,
} from 'src/app/shares/constants';
import {AddressService, AuthService} from 'src/app/shares/services';
import { UserService } from 'src/app/shares/services/user.service';
import { UserGroupService } from 'src/app/shares/services/user-group.service';
import { EventService } from 'src/app/shares/services/event.service';

@Component({
  selector: 'app-table-with-checkbox',
  templateUrl: './table-with-checkbox.component.html',
  styleUrls: ['./table-with-checkbox.component.scss'],
})
export class TableWitCheckboxComponent {
  @Input() configTable: ConfigTableInterface;
  @Output() actionClicked = new EventEmitter<any>();
  searchValue = '';
  pageSize: number = Pagination.PageSize;
  pageIndex: number = Pagination.PageIndex;
  totalPage = 0;
  clientSize = false;
  isAllDisplayDataChecked = false;
  isOperating = false;
  isIndeterminate = false;
  listOfDisplayData: any[]  = [];
  listOfAllData: any[];
  listOfProvince: any = [];
  provinceIds: any = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  numberOfChecked = 0;
  listUserGroupData: any[];
  userGroupIds: any = [2];
  eventId: number;
  listOfSelection = [
    {
      text: 'Select All Row',
      onSelect: () => {
        this.checkAll(true);
      },
    },
    {
      text: 'Select Odd Row',
      onSelect: () => {
        this.listOfDisplayData.forEach(
          (data, index) =>
            (this.mapOfCheckedId[data.userId] = index % 2 !== 0)
        );
        this.refreshStatus();
      },
    },
    {
      text: 'Select Even Row',
      onSelect: () => {
        this.listOfDisplayData.forEach(
          (data, index) =>
            (this.mapOfCheckedId[data.userId] = index % 2 === 0)
        );
        this.refreshStatus();
      },
    },
  ];
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private addressService: AddressService,
    private userGroupService: UserGroupService
  ) {
    this.listOfAllData = [];
  }

  setData(eventId) {
    this.eventId = eventId;
    this.getUserGroupData();
    this.getAvailableGuest();
    this.getProvinces();
  }

  checkPerAction(action) {
    if (action === Action.Back) { return true; }
    return this.authService.checkPermissionAction(action);
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(
      (item) => (this.mapOfCheckedId[item.userId] = value)
    );
    this.refreshStatus();
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.userId]);
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item.userId]) && !this.isAllDisplayDataChecked;
  }

  dataProperties(data) {
    const results = this.setDefaultResult();
    Object.keys(data).forEach((e) => {
      this.configTable.Header.forEach((value, index) => {
        if (value.Key === e) {
          let va = data[e];
          if (value.Type === Types.Date) {
            const t = new Date(va);
            va = t.getDate() + '/' + (t.getMonth() + 1) + '/' + t.getFullYear();
          }
          if (value.Type === Types.Time) {
            const t = new Date(va);
            va = t.getHours() + ':' + t.getMinutes();
          }
          results[index] = va;
        }
      });
    });
    return results;
  }

  setDefaultResult() {
    const res = [];
    this.configTable.Header.forEach((value, index) => {
      res.push('');
    });
    return res;
  }

  searchChanged($event) {
    if (this.searchValue !== '') {

    } else {
      this.listOfAllData = this.configTable.Data;
    }
  }

  filterData(filter: string) {
    this.listOfAllData = [];
    this.configTable.Data.forEach((element, index) => {
      let flag = false;
      Object.keys(element).forEach((e) => {
        const val = element[e] + '';
        if (val.toLowerCase().includes(filter.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        this.listOfAllData.push(element);
      }
    });
  }

  eventActionClicked(key, data) {
    this.actionClicked.emit({
      action: key,
      data,
    });

    // if (key === Action.PageChange) {
    //   this.getAvailableGuest();
    // }
  }

  changeUserGroup($event) {
    this.getAvailableGuest();
  }

  getUserGroupData() {
    this.userGroupService.getForSelect().subscribe(
      (res: ResponseResult) => {
        if (res.statusCode === StatusCode.Status200OK) {
          this.listUserGroupData = res.data.items;
          this.configTable.Data.UserGroupData = res.data.items;
        } else {
        }
      },
      (error) => {}
    );
  }

  getAvailableGuest(pageIndex: number = this.pageIndex) {
    const filterModel = {
      userGroupIds: this.userGroupIds,
      eventId: this.eventId,
      pageIndex,
      pageSize: Pagination.PageSize,
      provinceIds: this.provinceIds,
      filter: this.searchValue
    };
    this.userService
      .getAvailableGuest(filterModel)
      .subscribe(
        (res: ResponseResult) => {
          if (res.statusCode === StatusCode.Status200OK) {
            this.listOfAllData = res.data.items;
            this.configTable.Data = res.data.items;
            this.totalPage = res.data.totalItems;
          } else {
            this.listOfAllData = [];
          }
        },
        (error) => {}
      );
  }
  getProvinces(id: number = 237, langId: string = '') {
    this.listOfProvince = [];
    this.addressService.getProvinces(id, langId).subscribe((res: ResponseResult) => {
      if (res.statusCode === StatusCode.Status200OK) {
        this.listOfProvince = res.data;
      }
    }, error => {
      console.log('no data');
    });
  }
}
